module.exports = __webpack_public_path__ + "static/img/1.79f9201.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/1.png
// module id = eaf7
// module chunks = 0